(function() {
  // Configuration variables - get values from hidden fields
  let minWidth = parseInt(document.querySelector('[name="fabric_min_width_flat"]')?.value) || 25;
  let maxWidth = parseInt(document.querySelector('[name="fabric_max_width_flat"]')?.value) || 200;
  let maxWidthForPleat = parseInt(document.querySelector('[name="fabric_max_width_pleat"]')?.value) || 200;
  let minWidthForPleat = parseInt(document.querySelector('[name="fabric_min_width_pleat"]')?.value) || 25;
  let widthValue = minWidth;

  let minLengthFlat = parseInt(document.querySelector('[name="fabric_min_length_flat"]')?.value) || 14;
  let maxLengthFlat = parseInt(document.querySelector('[name="fabric_max_length_flat"]')?.value) || 275;
  let minLengthPleat = parseInt(document.querySelector('[name="fabric_min_length_pleat"]')?.value) || 14;
  let maxLengthPleat = parseInt(document.querySelector('[name="fabric_max_length_pleat"]')?.value) || 275;
  let lengthValue = minLengthFlat;

  // Flag to prevent multiple calculations during initialization
  let isInitializing = true;

  // Generate array of numbers with increment
  const generateDataForSizesIncrement = (min, max, increment) => {
    const arrayOfOptions = [];
    for (let i = min; i <= max; i += increment) {
      arrayOfOptions.push(i);
    }
    return arrayOfOptions;
  };

  // Generate array of numbers (1 by 1)
  const generateDataForSizes = (min, max) => {
    const arrayOfOptions = [];
    for (let i = min; i <= max; i++) {
      arrayOfOptions.push(i);
    }
    return arrayOfOptions;
  };

  // Create select options in dropdown
  const createSelectOptions = (data, selectId) => {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;

    selectElement.innerHTML = '';
    data.forEach((option, index) => {
      const optionElement = document.createElement('option');
      optionElement.value = option;
      optionElement.textContent = option;
      if (index === 0) {
        optionElement.selected = true;
      }
      selectElement.appendChild(optionElement);
    });
  };

  const subscribeToQuantityUpdates = () => {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {

      if (window.productQuantityUpdateUnsubscribers) {
        window.productQuantityUpdateUnsubscribers.forEach((unsub) => unsub?.());
      }
      window.productQuantityUpdateUnsubscribers = [];

      const runSharedInventorySync = (data = {}) => {
        const actualInventoryEl = document.getElementById("shared_inventory");
        if (!actualInventoryEl) return;

        const actualInventory = parseInt(actualInventoryEl.value, 10) || 0;
        const productId = document.querySelector('input[name="product_id"]')?.value;
        if (!productId) return;

        const inventoryQuantityField = document.querySelector(`input[name="product_${productId}_inventory_quantity"]`);
        const inventoryProductId = document.querySelector(`input[name="product_${productId}_inventory_product_id"]`)?.value;
        if (!inventoryQuantityField || !inventoryProductId) return;

        let cartQuantity = 0;
        // Prefer the most authoritative source: full cart JSON from the cart
        // events. This is always consistent with the server state.
        if (data.cartData?.items) {
          data.cartData.items.forEach((item) => {
            if (String(item.properties?._inventory_product_id || '') === String(inventoryProductId)) {
              const yardsPerUnit = Math.ceil(parseFloat(item.properties?._yards_per_unit || '1'));
              cartQuantity += yardsPerUnit * (item.quantity || 0);
            }
          });
        } else {
          // Next best: sum the currently rendered cart-drawer rows.
          const cartInputs = document.querySelectorAll('input[name="updates[]"][data-inventory-product-id]');
          if (cartInputs.length > 0) {
            cartInputs.forEach((input) => {
              if (String(input.dataset.inventoryProductId || '') !== String(inventoryProductId)) return;
              const qty = parseInt(input.value, 10) || 0;
              const yardsPerUnit = Math.ceil(parseFloat(input.dataset.yards || '1'));
              cartQuantity += qty * yardsPerUnit;
            });
          } else if (data.quantityForm) {
            // Server-re-rendered quantity form (from product-info.js).
            // Used only when no richer source is available.
            const cartQuantityInput = data.quantityForm.querySelector('.quantity__input');
            cartQuantity = cartQuantityInput ? parseInt(cartQuantityInput.getAttribute('data-cart-quantity'), 10) || 0 : 0;
          } else {
            const liveQtyInput = document.getElementById('product-configurator-quantity');
            cartQuantity = liveQtyInput ? parseInt(liveQtyInput.getAttribute('data-cart-quantity'), 10) || 0 : 0;
          }
        }

        const remainingQuantity = Math.max(actualInventory - cartQuantity, 0);
        inventoryQuantityField.value = remainingQuantity;

        // After a successful add-to-cart from this product form, reset the
        // configurator quantity back to 1 so the next ATC click doesn't
        // re-add the previously selected quantity.
        if (data.source === 'product-form') {
          const liveQtyInput = document.getElementById('product-configurator-quantity');
          if (liveQtyInput) liveQtyInput.value = 1;
        }

        updateQuantityInput();
        calculatePrice();
      };

      // Cart updates for a single user action fire multiple events in quick
      // succession (cartUpdate, cartUpdateInMiniCart, quantity-update-rules),
      // sometimes with partial data. Debounce + merge so we only re-render
      // once using the richest payload, which avoids the configurator
      // flickering between intermediate states.
      let pendingData = null;
      let pendingTimer = null;
      const applySharedInventoryFromEvent = (data = {}) => {
        if (!pendingData) pendingData = {};
        if (data.cartData?.items) pendingData.cartData = data.cartData;
        if (data.quantityForm) pendingData.quantityForm = data.quantityForm;
        if (data.source) pendingData.source = data.source;

        if (pendingTimer) clearTimeout(pendingTimer);
        pendingTimer = setTimeout(() => {
          const merged = pendingData || {};
          pendingData = null;
          pendingTimer = null;
          runSharedInventorySync(merged);
        }, 60);
      };

      window.productQuantityUpdateUnsubscribers.push(
        subscribe("quantity-update-rules", applySharedInventoryFromEvent)
      );
      window.productQuantityUpdateUnsubscribers.push(
        subscribe(PUB_SUB_EVENTS.cartUpdate, applySharedInventoryFromEvent)
      );
      if (PUB_SUB_EVENTS.cartUpdateInMiniCart) {
        window.productQuantityUpdateUnsubscribers.push(
          subscribe(PUB_SUB_EVENTS.cartUpdateInMiniCart, applySharedInventoryFromEvent)
        );
      }

      // Initial sync on page load/re-entry (bypass debounce so the
      // configurator is ready immediately).
      runSharedInventorySync();
    } else {
      console.warn('⚠️ PUB_SUB_EVENTS or subscribe function not available');
    }
  };

  // Initialize dropdowns when DOM is ready
  const initializeDropdowns = () => {
    // Generate options arrays
    const widthOptions = generateDataForSizesIncrement(minWidth, maxWidth, 25);
    const lengthOptions = generateDataForSizes(minLengthFlat, maxLengthFlat);

    // Create dropdown options
    createSelectOptions(widthOptions, "product-configurator-width-select");
    createSelectOptions(lengthOptions, "product-configurator-height-select");

    // Set initial values
    widthValue = widthOptions[0];
    lengthValue = lengthOptions[0];

    // Add event listeners
    setupEventListeners();

    // Initialize yards display and quantity input
    updateYardsDisplay();
    updateQuantityInput();


  };

  // Price calculation functions (adapted from configurator-product.js)
  const getWidthForCalculation = (width, paneltype) => {
    let widthInt = parseInt(width);
    if (paneltype === "flat") {
      if (widthInt < 51) {
        return 1;
      } else if (widthInt >= 51 && widthInt < 101) {
        return 2;
      } else if (widthInt >= 101 && widthInt < 151) {
        return 3;
      } else if (widthInt >= 151) {
        return 4;
      }
    } else {
      if (widthInt < 26) {
        return 1;
      } else if (widthInt >= 26 && widthInt < 51) {
        return 2;
      } else if (widthInt >= 51 && widthInt < 76) {
        return 3;
      } else if (widthInt >= 76 && widthInt < 101) {
        return 4;
      } else if (widthInt >= 101 && widthInt < 126) {
        return 5;
      } else if (widthInt >= 126 && widthInt < 151) {
        return 6;
      } else if (widthInt >= 151 && widthInt < 176) {
        return 7;
      } else if (widthInt >= 176) {
        return 8;
      }
    }
  };

  const calculatePrice = (updatePriceItems = true) => {
    // Skip calculation during initialization to prevent multiple calls
    if (isInitializing) {
      return 0;
    }

    // Get selected lining and header data
    const selectedLining = window.selectedLining;
    const selectedHeader = window.selectedHeader;

    if (!selectedLining || !selectedHeader) {
      //console.log('Missing lining or header selection');
      return 0;
    }

    // Get pricing data from form inputs or data attributes
    const pricePerYardInput = document.querySelector('input[name="price_per_yard"]');
    const discountInput = document.querySelector('input[name="custom_product_discount"]');

    // Convert Shopify prices from cents to dollars
    const liningBasePrice = (parseFloat(selectedLining.price) / 100) || 0;
    const headerSelected = selectedHeader.title || '';
    const fabricationBasePrice = (parseFloat(selectedHeader.price) / 100) || 0;

    // Get panel type from the selected header's product card
    const selectedHeaderButton = document.querySelector('.product-options-card__select-header.selected');
    const paneltype = selectedHeaderButton ? selectedHeaderButton.getAttribute('data-image-panel-type') || 'flat' : 'flat';

    const widthForCalculation = getWidthForCalculation(widthValue, paneltype);
    const liningWeight = parseFloat(selectedLining.weight) || 0;
    const pricePerYard = pricePerYardInput ? parseFloat(pricePerYardInput.value) || 0 : 15; // Default fallback
    const cusDiscountVal = discountInput ? parseFloat(discountInput.value) || 0 : 0;

    // Calculate total yards
    const totalYards = ((16 + parseFloat(lengthValue)) / 36) * parseInt(widthForCalculation);

    // Get shipping price per pound from hidden field
    const shippingPricePerPoundInput = document.querySelector('input[name="shipping_price_per_pound"]');
    const pricePerPound = shippingPricePerPoundInput ? parseFloat(shippingPricePerPoundInput.value) || 11.85 : 11.85;

    const productId = document.querySelector('input[name="product_id"]')?.value
    const inventoryQuantityField = document.querySelector(`input[name="product_${productId}_inventory_quantity"]`).value;
    const quantity = parseInt(document.getElementById('product-configurator-quantity').value) || 1;

    let priceForRuched = 0;

    // Check if header includes ruched pricing
    if (headerSelected.toLowerCase().includes("ruched")) {
      priceForRuched = widthForCalculation * 1.5 * pricePerYard;
    }

    // Calculate individual costs
    const fabricCost = (totalYards * pricePerYard + priceForRuched);
    const liningCost = (totalYards * liningBasePrice);
    const fabricationCost = (widthForCalculation * fabricationBasePrice);
    const weightCost = liningWeight * totalYards * pricePerPound;

    const extraCharge = parseFloat(document.querySelector('input[name="product_extra_cost"]').value) || 0;

    const total = fabricCost + liningCost + fabricationCost + weightCost + extraCharge;

    // Apply discount
    const toFixedTotal = total.toFixed(2)
    const percentageValue = parseInt(cusDiscountVal) || 0;
    const discountValue = toFixedTotal / 100 * percentageValue;
    const discountedTotal = toFixedTotal - discountValue;

    // Update price display elements
    updatePriceDisplay(total, discountedTotal);
    updateTotalPriceDisplay(total, discountedTotal, updatePriceItems);

    // Log calculation details for debugging
    //console.clear();
    console.log('Price Calculation Details:', {
      totalWithOutDiscount: total.toFixed(2),
      pricePerPound,
      panelType: paneltype,
      discountPercentage: percentageValue,
      widthForCalculation,
      totalYards: Math.ceil(totalYards.toFixed(2)),
      headerSelected: headerSelected,
      //fabricCost: fabricCost.toFixed(2),
      //liningCost: liningCost.toFixed(2),
      fabricationBasePrice: fabricationCost.toFixed(2),
      weightCost: weightCost.toFixed(2),
      weightPricePerWidth: liningWeight,
      extraCharge: extraCharge,
      pricePerYard: pricePerYard,
      discountValue: discountValue.toFixed(2),
      totalWithDiscount: discountedTotal.toFixed(2),
      totalAvailableQuantity:inventoryQuantityField
    });

    //const quantity = parseInt(document.getElementById('product-configurator-quantity').value) || 1;
    const totalWithQuantity = discountedTotal * quantity;
    const variantIdInput = document.querySelector('input[name="variant_id"]');
    const variantId = variantIdInput ? variantIdInput.value : null;
    const productData = getSelectedProductData();

    // Update hidden fields with existence checks
    const attrTotalCalculatedPrice = document.getElementById('attr_total_calculated_price');
    if (attrTotalCalculatedPrice) attrTotalCalculatedPrice.value = totalWithQuantity.toFixed(2) || 0;

    const attrPricePerUnit = document.getElementById('attr_price_per_unit');
    if (attrPricePerUnit) attrPricePerUnit.value = discountedTotal.toFixed(2) || 0;

    const attrVariantId = document.getElementById('attr_variant_id');
    if (attrVariantId) attrVariantId.value = variantId;

    const attrYardsPerUnit = document.getElementById('attr_yards_per_unit');
    if (attrYardsPerUnit) attrYardsPerUnit.value = totalYards.toFixed(2) || 0;

    const attrInventoryProductId = document.getElementById('attr_inventory_product_id');
    if (attrInventoryProductId) attrInventoryProductId.value = productData?.inventory_product_id || 0;

    return discountedTotal;
  };

  const updatePriceDisplay = (regularPrice, discountedPrice) => {
    // Update regular price elements
    const regularPriceElements = document.querySelectorAll('.regular-price, .product-configurator-regular-price');
    regularPriceElements.forEach(el => {
      el.textContent = `$${regularPrice.toFixed(2)}`;
    });

    // Update discounted price elements
    const discountedPriceElements = document.querySelectorAll('.discounted-price, .product-configurator-price, .configurator-price');
    discountedPriceElements.forEach(el => {
      el.textContent = `$${discountedPrice.toFixed(2)}`;
    });

    // Update any total price elements
    const totalPriceElements = document.querySelectorAll('.total-price, .product-configurator-total-price');
    totalPriceElements.forEach(el => {
      el.textContent = `$${discountedPrice.toFixed(2)}`;
    });
  };

  // Setup event listeners for dropdowns
  const setupEventListeners = () => {

    const widthSelect = document.getElementById("product-configurator-width-select");
    const heightSelect = document.getElementById("product-configurator-height-select");

    if (widthSelect) {
      widthSelect.addEventListener('change', function() {
        widthValue = this.value;
        updateDisplay();
        updateYardsDisplay();
        updateQuantityInput();
        calculatePrice(); // Recalculate price when width changes
      });
    }

    if (heightSelect) {
      heightSelect.addEventListener('change', function() {
        lengthValue = this.value;
        updateDisplay();
        updateYardsDisplay();
        updateQuantityInput();
        calculatePrice(); // Recalculate price when height changes
      });
    }

    // Setup lining product selection
    setupLiningSelection();

    // Setup header product selection
    setupHeaderSelection();

    // Setup price input change listeners
    setupPriceInputListeners();

    // Setup quantity controls
    setupQuantityControls();
  };

  // Setup listeners for price-related inputs
  const setupPriceInputListeners = () => {
    const pricePerYardInput = document.querySelector('input[name="price_per_yard"]');
    const discountInput = document.querySelector('input[name="custom_product_discount"]');

    if (pricePerYardInput) {
      pricePerYardInput.addEventListener('change', calculatePrice);
    }

    if (discountInput) {
      discountInput.addEventListener('change', calculatePrice);
    }
  };

  // Update display elements
  const updateDisplay = () => {
    // Update any display elements that show current selection

    const dynamicWidthValues = document.querySelectorAll('.dynamic_width_value');
    const dynamicLengthValues = document.querySelectorAll('.dynamic_length_value');

    // Update all width elements
    dynamicWidthValues.forEach(element => {
      element.textContent = `${widthValue}`;
    });

    // Update all length elements
    dynamicLengthValues.forEach(element => {
      element.textContent = `${lengthValue}`;
    });

    const attrWidth = document.getElementById('attr_width');
    if (attrWidth) attrWidth.value = widthValue;

    const attrHeight = document.getElementById('attr_height');
    if (attrHeight) attrHeight.value = lengthValue;

    const attrSize = document.getElementById('attr_size');
    if (attrSize) attrSize.value = widthValue + "\" W X " + lengthValue + "\" L";

    // Update yards calculation display
    updateYardsDisplay();
  };

  // Update width dropdown options based on panel type
  const updateWidthOptionsBasedOnPanelType = (paneltype) => {
    if (paneltype === "flat") {
      const widthOptions = generateDataForSizesIncrement(minWidth, maxWidth, 25);
      createSelectOptions(widthOptions, "product-configurator-width-select");
      //console.log('Updated to flat panel width options:', widthOptions);
      widthValue = minWidth;
    } else if (paneltype.toLowerCase() === "pleated") {
      const widthOptionsForPleat = generateDataForSizes(minWidthForPleat, maxWidthForPleat);
      createSelectOptions(widthOptionsForPleat, "product-configurator-width-select");
      //console.log('Updated to pleat panel width options:', widthOptionsForPleat);
      widthValue = minWidthForPleat;
    }

    // Update display and calculations
    updateDisplay();
    updateYardsDisplay();
    updateQuantityInput();

    //console.log(`Width dropdown updated for ${paneltype} panel type, width reset to:`, widthValue);
  };

  // Update length dropdown options based on panel type
  const updateLengthOptionsBasedOnPanelType = (paneltype) => {
    if (paneltype === "flat") {
      const lengthOptions = generateDataForSizes(minLengthFlat, maxLengthFlat);
      createSelectOptions(lengthOptions, "product-configurator-height-select");
      //console.log('Updated to flat panel length options:', lengthOptions);
      lengthValue = minLengthFlat;
    } else if (paneltype.toLowerCase() === "pleated") {
      const lengthOptionsForPleat = generateDataForSizes(minLengthPleat, maxLengthPleat);
      createSelectOptions(lengthOptionsForPleat, "product-configurator-height-select");
      //console.log('Updated to pleat panel length options:', lengthOptionsForPleat);
      lengthValue = minLengthPleat;
    }

    // Update display and calculations
    updateDisplay();
    updateYardsDisplay();
    updateQuantityInput();

    //console.log(`Length dropdown updated for ${paneltype} panel type, length reset to:`, lengthValue);
  };

  // Setup lining product selection
  const setupLiningSelection = () => {
    const liningButtons = document.querySelectorAll('.select-lining-btn');
    liningButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Remove active class from all lining buttons
        liningButtons.forEach(btn => btn.classList.remove('selected'));

        // Add active class to clicked button
        this.classList.add('selected');

        const productId = this.getAttribute('data-product-id');
        const price = this.getAttribute('data-price');
        const title = this.getAttribute('data-title');
        const weight = this.getAttribute('data-weight');

        // Get description from hidden HTML element
        const descriptionElement = document.getElementById(`product-description-${productId}`);
        const description = descriptionElement ? descriptionElement.innerHTML : '';

        //console.log('Lining selected:', { productId, price, title, weight, description });

        // Store selected lining data
        window.selectedLining = { productId, price, title, weight, description };
        updateSelectionDisplay();
        document.dispatchEvent(new CustomEvent('hpd:configurator:selection-updated'));
      });

      // Add hover functionality
      button.addEventListener('mouseenter', function() {
        const hoverTitle = this.getAttribute('data-title');
        const selectedLiningTitle = document.querySelector('.selected-lining-title');
        const liningTitleElement = selectedLiningTitle ? selectedLiningTitle.querySelector('.selected-lining-title__title') : null;

        if (liningTitleElement) {
          liningTitleElement.textContent = hoverTitle;
        }
      });

      button.addEventListener('mouseleave', function() {
        const selectedLiningTitle = document.querySelector('.selected-lining-title');
        const liningTitleElement = selectedLiningTitle ? selectedLiningTitle.querySelector('.selected-lining-title__title') : null;

        if (liningTitleElement) {
          const savedTitle = liningTitleElement.getAttribute('data-lining-title');
          if (savedTitle) {
            liningTitleElement.textContent = savedTitle;
          }
        }
      });

    });
  };

  // Setup header product selection
  const setupHeaderSelection = () => {

    const headerButtons = document.querySelectorAll('.product-options-card__select-header');
    headerButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Remove active class from all header buttons
        headerButtons.forEach(btn => btn.classList.remove('selected'));

        // Add active class to clicked button
        this.classList.add('selected');

        const productId = this.getAttribute('data-product-id');
        const price = this.getAttribute('data-price');
        const headerTitle = this.getAttribute('data-title');

        // Get description from hidden HTML element or fall back to data attribute
        const descriptionElement = document.getElementById(`product-description-${productId}`);
        const description = descriptionElement ? descriptionElement.innerHTML : '';

        //console.log('Header selected:', { productId, price, title, description });

        // Get panel type from the header card

        const paneltype = this.getAttribute('data-image-panel-type') || 'flat';

        //console.log('Panel type selected:', paneltype);

        // Update width dropdown based on panel type
        updateWidthOptionsBasedOnPanelType(paneltype);

        // Update length dropdown based on panel type
        updateLengthOptionsBasedOnPanelType(paneltype);

        const title = headerTitle.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        // Store selected header data
        window.selectedHeader = { productId, price, title, description };
        updateSelectionDisplay();
        document.dispatchEvent(new CustomEvent('hpd:configurator:selection-updated'));
        updateYardsDisplay();
        updateQuantityInput();
      });

      // Add hover functionality
      button.addEventListener('mouseenter', function() {
        const hoverTitle = this.getAttribute('data-title');
        const selectedHeaderTitle = document.querySelector('.selected-header-title');
        const headerTitleElement = selectedHeaderTitle ? selectedHeaderTitle.querySelector('.selected-header-title__title') : null;

        if (headerTitleElement) {
          headerTitleElement.textContent = window.selectedHeader.title;
        }
      });

      button.addEventListener('mouseleave', function() {
        const selectedHeaderTitle = document.querySelector('.selected-header-title');
        const headerTitleElement = selectedHeaderTitle ? selectedHeaderTitle.querySelector('.selected-header-title__title') : null;

        if (headerTitleElement) {
          const savedTitle = headerTitleElement.getAttribute('data-header-title');
          if (savedTitle) {
            headerTitleElement.textContent = window.selectedHeader.title;
          }
        }
      });
    });
  };

  // Update selection display
  const updateSelectionDisplay = () => {
    // Update size display
    const dynamicWidthValues = document.querySelectorAll('.dynamic_width_value');
    const dynamicLengthValues = document.querySelectorAll('.dynamic_length_value');

    // Update all width elements
    dynamicWidthValues.forEach(element => {
      element.textContent = `${widthValue}`;
    });

    // Update all length elements
    dynamicLengthValues.forEach(element => {
      element.textContent = `${lengthValue}`;
    });

    // Update header selection display
    const headerTitles = document.querySelectorAll('.selected-header-title__title');
    const headerPanels = document.querySelectorAll('.selected-header-panel');
    const headerPrices = document.querySelectorAll('.selected-header-price');
    const headerDescriptions = document.querySelectorAll('.selected-header-description');

    if (window.selectedHeader) {
      const selectedHeaderButton = document.querySelector('.select-header-btn.selected');
      const paneltype = selectedHeaderButton ? selectedHeaderButton.getAttribute('data-image-panel-type') || 'flat' : 'flat';

      // Update all header title elements (HTML content for all instances)
      headerTitles.forEach(element => {
        element.innerHTML = `${window.selectedHeader.title}`;
      });

      // Update data attribute only on the specific child element
      const selectedHeaderTitle = document.querySelector('.selected-header-title');
      const headerTitleElement = selectedHeaderTitle ? selectedHeaderTitle.querySelector('.selected-header-title__title') : null;
      if (headerTitleElement) {
        headerTitleElement.setAttribute('data-header-title', window.selectedHeader.title);

        const attrHeader = document.getElementById('attr_header');
        if (attrHeader) attrHeader.value = window.selectedHeader.title;

        const attrPanelType = document.getElementById('attr_panel_type');
        if (attrPanelType) attrPanelType.value = paneltype;
      }

      // Update all header panel elements
      headerPanels.forEach(element => {
        element.innerHTML = `(${paneltype} Panel)`;
      });

      // Update all header price elements
      headerPrices.forEach(element => {
        element.innerHTML = `$${(window.selectedHeader.price / 100).toFixed(2)}`;
      });

      // Update all header description elements
      headerDescriptions.forEach(element => {
        element.innerHTML = window.selectedHeader.description || '';
      });
    } else {
      // Clear all header elements when no header is selected
      headerTitles.forEach(element => {
        element.textContent = '';
      });
      headerDescriptions.forEach(element => {
        element.textContent = '';
      });
    }

    // Update lining selection display
    const liningTitles = document.querySelectorAll('.selected-lining-title__title');
    const liningDescriptions = document.querySelectorAll('.selected-lining-description');

    const selectedLiningTitle = document.querySelector('.selected-lining-title');
    const liningTitleElement = selectedLiningTitle ? selectedLiningTitle.querySelector('.selected-lining-title__title') : null;


    if (window.selectedLining) {
      if (liningTitleElement) {
        liningTitleElement.setAttribute('data-lining-title', window.selectedLining.title);

        const attrLining = document.getElementById('attr_lining');
        if (attrLining) attrLining.value = window.selectedLining.title;
        // const attrLiningWeight = document.getElementById('attr_lining_weight');
        // if (attrLiningWeight) attrLiningWeight.value = window.selectedLining.weight;
      }

      // Update all lining title elements
      liningTitles.forEach(element => {
        element.innerHTML = `${window.selectedLining.title}`;
      });

      // Update all lining description elements
      liningDescriptions.forEach(element => {
        element.innerHTML = window.selectedLining.description || '';
      });
    } else {
      // Clear all lining elements when no lining is selected
      liningTitles.forEach(element => {
        element.textContent = 'Please select a lining product';
      });
      liningDescriptions.forEach(element => {
        element.textContent = 'No lining selected';
      });
    }

    // Calculate and display price (only if not initializing)
    if (!isInitializing) {
      calculatePrice();
    }
    updateAddToCartButton();
  };

  // Update total price display and add to cart button state
  const updateTotalPriceDisplay = (total = null, singlePrice = null, updatePriceItems = true) => {
    // If no single price provided, calculate it (only when called independently and not initializing)
    if (singlePrice === null && !isInitializing) {
      singlePrice = calculatePrice(updatePriceItems);
    } else if (singlePrice === null) {
      singlePrice = 0; // Default to 0 during initialization
    }

    const quantityInput = document.getElementById('product-configurator-quantity');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    const quantityField = document.querySelector('.product-form-main #quantity');
    if (quantityField) {
      quantityField.value = quantity;
    }

    const totalPrice = (singlePrice.toFixed(2)) * quantity;

    // ALWAYS update the total display
    const totalDisplayElement = document.querySelector('.product-configurator-total-display');
    if (totalDisplayElement) {
      totalDisplayElement.textContent = `$${totalPrice.toFixed(2)}`;
    }

    // Update cutoff price (original price before discount) scaled by quantity
    const cutoffDisplayElement = document.querySelector('.product-configurator-total-cutoff');
    const discountPercentageElement = document.querySelector('.product-configurator-total-discount-percentage');

    if (cutoffDisplayElement && total !== null) {
      const totalCutoffPrice = total * quantity;
      cutoffDisplayElement.textContent = `$${totalCutoffPrice.toFixed(2)}`;

      // Show/hide cutoff price based on whether there's a discount
      const cutoffWrapper = cutoffDisplayElement.closest('.product-form__total-price-cutoff');
      if (cutoffWrapper) {
        if (total > singlePrice) {
          cutoffWrapper.style.display = '';
        } else {
          cutoffWrapper.style.display = 'none';
        }
      }
    }

    // Update discount percentage display
    if (discountPercentageElement && total !== null) {
      const discountWrapper = discountPercentageElement.closest('.product-form__total-price-discount');
      if (discountWrapper) {
        if (total > singlePrice) {
          const discountPercentage = Math.round(((total - singlePrice) / total) * 100);
          discountPercentageElement.textContent = `${discountPercentage}% off`;
          discountWrapper.style.display = '';
        } else {
          discountWrapper.style.display = 'none';
        }
      }
    }

    // ONLY update price items when configuration changes (not on quantity change)
    if (updatePriceItems) {
      const sectionEl = document.querySelector('input[name="section_id"]');

      if (sectionEl) {

        const sectionId = sectionEl.value;

        const priceSectionEl = document.querySelectorAll(`#price-${sectionId}`);

        if (priceSectionEl) {

          priceSectionEl.forEach(priceSection => {

            //if there is not on sale
            const regularPrice = priceSection.querySelector('.price__regular');
            if(regularPrice){
              const priceItemRegular = regularPrice.querySelector('.price-item--regular');
              if (priceItemRegular) {
                priceItemRegular.textContent = `$${parseFloat(singlePrice).toFixed(2)}`;
              }
            }

            //if there is a sale
            const salePrice = priceSection.querySelector('.price__sale');
            if(salePrice){
              const priceItemLast = salePrice.querySelector('.price-item--last');
              if (priceItemLast) {
                priceItemLast.textContent = `$${parseFloat(singlePrice).toFixed(2)}`;
              }

              const tradeCustomer = document.querySelector('input[name="trade_customer"]')?.value;
              if(tradeCustomer){
                if(total && total > singlePrice) {
                  const discountPercentage = Math.round(((total - singlePrice) / total) * 100);
                  const salePercentageEl = priceSection.querySelector('.sale-percentage');
                  if (salePercentageEl) {
                    salePercentageEl.textContent = `${discountPercentage}% off`;
                  }
                }
              }

              if(total) {
                const priceItemRegular = salePrice.querySelector('.price-item--regular');
                if (priceItemRegular) {
                  priceItemRegular.textContent = `$${total.toFixed(2)}`;
                }
              }
            }
          });
        }
      }
    }
  };

  // Update add to cart button state
  const updateAddToCartButton = () => {
    const addToCartButton = document.getElementById('product-configurator-add-to-cart');
    const hasLining = window.selectedLining;
    const hasHeader = window.selectedHeader;
    

    const quantityInput = document.getElementById("product-configurator-quantity");
    if(quantityInput){
      const maxQuantity = quantityInput.max
      if(maxQuantity < 1){
        quantityInput.value = 0;
        disableATC();
        return;
      }
    } else {
      enableATC()
    }

    if (addToCartButton) {
      if (hasLining && hasHeader) {
        addToCartButton.disabled = false;
        addToCartButton.style.opacity = '1';
        addToCartButton.style.cursor = 'pointer';
        addToCartButton.textContent = 'Add to Cart';
      } else {
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = '0.5';
        addToCartButton.style.cursor = 'not-allowed';
        addToCartButton.textContent = 'Select Products First';
      }

    }
  };

  // Setup quantity controls
  // Calculate yards based on width and height
  const calculateYards = () => {

    // Get panel type from selected header
    const selectedHeaderButton = document.querySelector('.select-header-btn.selected');
    let paneltype = "flat"
    if(selectedHeaderButton){
      paneltype = selectedHeaderButton.getAttribute('data-image-panel-type') || 'flat';
    }

    const widthForCalculation = getWidthForCalculation(widthValue, paneltype);
    const totalYards = ((16 + parseFloat(lengthValue)) / 36) * parseInt(widthForCalculation);

    return {
      totalYards: totalYards,
      widthForCalculation: widthForCalculation,
      paneltype: paneltype
    };
  };

  // Update yards calculation display
  const updateYardsDisplay = () => {

    const yardsCalculation = calculateYards();
    const displayElement = document.querySelector('.yards-calculation-display');

    if (displayElement) {
      displayElement.textContent = `${widthValue}" W × ${lengthValue}" H = ${yardsCalculation.totalYards.toFixed(2)} yards (${yardsCalculation.widthForCalculation} panels)`;
    }

    // Update hidden input
    const calculatedYardsInput = document.getElementById('calculated-yards');
    if (calculatedYardsInput) {
      calculatedYardsInput.value = yardsCalculation.totalYards.toFixed(2);
    }
  };

  // Helper function to get variant ID from hidden field
  const getVariantId = () => {
    const variantIdInput = document.querySelector('input[name="variant_id"]');
    return variantIdInput ? variantIdInput.value : null;
  };

  // Helper function to get product data from hidden fields
  const getProductDataFromHiddenFields = () => {
    // Get the product ID from the current page URL or a hidden field
    const productId = document.querySelector('input[name="product_id"]')?.value

    //console.log("Getting product data for:", productId);

    const inventoryQuantityField = document.querySelector(`input[name="product_${productId}_inventory_quantity"]`);
    const inventoryPolicyField = document.querySelector(`input[name="product_${productId}_inventory_policy"]`);
    const inventoryManagementField = document.querySelector(`input[name="product_${productId}_inventory_management"]`);
    const priceField = document.querySelector(`input[name="product_${productId}_price"]`);
    const availableField = document.querySelector(`input[name="product_${productId}_available"]`);
    const titleField = document.querySelector(`input[name="product_${productId}_title"]`);
    const inventoryProductIdField = document.querySelector(`input[name="product_${productId}_inventory_product_id"]`);

    if(!inventoryQuantityField){
      disableATC();
      const quantitySelector = document.querySelector(`.quantity-selector-${productId}`);
      if (quantitySelector) {
        quantitySelector.style.display = "none";
      }
    }
    if (!inventoryQuantityField || !priceField || !availableField) {
      console.warn(`Product data not found for product ID: ${productId}`);
    }

    return {
      id: productId,
      title: titleField ? titleField.value : '',
      price: parseInt(priceField?.value) || 0,
      inventory_quantity: parseInt(inventoryQuantityField?.value) || 0,
      inventory_policy: inventoryPolicyField ? inventoryPolicyField.value : 'deny',
      inventory_management: inventoryManagementField ? inventoryManagementField.value : null,
      available: availableField ? availableField.value === 'true' : false,
      inventory_product_id: inventoryProductIdField ? inventoryProductIdField.value : ''
    };
  };

  // Get selected product data
  const getSelectedProductData = () => {
    // Use the globally stored Shopify product data
    if (window.selectedShopifyProduct) {
      return {
        productId: window.selectedShopifyProduct.id,
        inventoryQuantity: window.selectedShopifyProduct.inventory_quantity,
        inventoryPolicy: window.selectedShopifyProduct.inventory_policy,
        inventoryManagement: window.selectedShopifyProduct.inventory_management,
        price: window.selectedShopifyProduct.price,
        available: window.selectedShopifyProduct.available,
        inventory_product_id: window.selectedShopifyProduct.inventory_product_id
      };
    }

    // Get product details from hidden fields
    const productData = getProductDataFromHiddenFields();

    if (productData) {
      return {
        productId: productData.id,
        inventoryQuantity: productData.inventory_quantity,
        inventoryPolicy: productData.inventory_policy,
        inventoryManagement: productData.inventory_management,
        price: productData.price,
        available: productData.available,
        inventory_product_id: productData?.inventory_product_id
      };
    }

    return null;
  };

  const disableATC = () => {
    const productId = document.querySelector('input[name="product_id"]')?.value;
    if (!productId) return;

    const ATC_buton = document.querySelector(`.product-form__submit-${productId}`);
    if (!ATC_buton) return;

    const textSpan = ATC_buton.querySelector('.text-span');
    if (textSpan) textSpan.textContent = "Sold out";

    ATC_buton.style.opacity = "0.5";
    ATC_buton.style.cursor = "not-allowed";
    ATC_buton.disabled = true;
  }
  const enableATC = () => {
    const productId = document.querySelector('input[name="product_id"]')?.value;
    if (!productId) return;

    const addToCartButton = document.querySelector(`.product-form__submit-${productId}`);
    if (!addToCartButton) return;

    // Don't enable the button until the page has fully loaded
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function() {
        enableATC();
      }, { once: true });
      return;
    }

    addToCartButton.disabled = false;
    addToCartButton.style.opacity = '1';
    addToCartButton.style.cursor = 'pointer';

    const textSpan = addToCartButton.querySelector('.text-span');
    if (textSpan) textSpan.textContent = 'Add to Cart';
  }
  const disableQuantityInputField = () => {
    const quantityInput = document.getElementById('product-configurator-quantity');
    quantityInput.disabled = true;
    quantityInput.value = 0;
    quantityInput.max = 0;
    quantityInput.setAttribute('data-max', 0);
    disableATC()
  }

  // Populate quantity dropdown based on selected variant inventory
  const updateQuantityInput = () => {
    const quantityInput = document.getElementById('product-configurator-quantity');

    if (!quantityInput) {
      console.warn('❌ quantityInput element not found!');
      return;
    }

    const plusButton = quantityInput.parentElement.querySelector('button[name="plus"]');
    const minusButton = quantityInput.parentElement.querySelector('button[name="minus"]');
    const productData = getSelectedProductData();

    if (!productData) {
      console.warn('❌ productData not found!');
      return;
    }

    const yardsPerUnit = Math.ceil(calculateYards().totalYards);
    const { inventoryQuantity, inventoryPolicy, available } = productData;

    // Handle unavailable product
    if (!available || (inventoryPolicy === 'deny' && inventoryQuantity <= 0)) {
      disableQuantityInputField();
      minusButton.classList.add('disabled');
      plusButton.classList.add('disabled');
      return;
    }

    // Compute maximum quantity in units
    const maxQuantity = yardsPerUnit > 0
      ? Math.floor(inventoryQuantity / yardsPerUnit)
      : inventoryQuantity;

    const actualMaxQuantity = maxQuantity;

    const hasEnoughInventory = inventoryQuantity >= yardsPerUnit;

    // Common input setup
    quantityInput.disabled = false;
    quantityInput.min = 1;
    quantityInput.max = actualMaxQuantity;
    quantityInput.setAttribute('data-max', actualMaxQuantity);

    // ATC + buttons state
    if (actualMaxQuantity < 1 || !hasEnoughInventory) {
      quantityInput.value = 0;
      quantityInput.disabled = true;
      disableATC();
      plusButton.classList.add('disabled');
      updateQuantitySummary(quantityInput);
    } else {
      quantityInput.value = Math.min(
        Math.max(parseInt(quantityInput.value) || 1, 1),
        actualMaxQuantity
      );
      enableATC();

      const currentValue = parseInt(quantityInput.value) || 1;

      // Disable minus if at 1, disable plus if at max
      minusButton.classList.toggle('disabled', currentValue <= 1);
      plusButton.classList.toggle('disabled', currentValue >= actualMaxQuantity);
      updateQuantitySummary(quantityInput);
    }
  };

  // Setup variant selection is now handled by Shopify's default variant selector
  // through the mutation observer and bindVariantListener function

  // Setup quantity controls (number input-based)
  const setupQuantityControls = () => {
    const quantityInput = document.getElementById('product-configurator-quantity');

    if (quantityInput) {
      // Listen for both input and change events
      quantityInput.addEventListener('input', function() {

        updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
        updateAddToCartButton();
        updateQuantitySummary(quantityInput);
      });

      quantityInput.addEventListener('change', function() {

        updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
        updateAddToCartButton();
        updateQuantitySummary(quantityInput);
      });

      // Validate input to ensure it doesn't exceed max
      quantityInput.addEventListener('blur', function() {
        const max = parseInt(quantityInput.max);
        const min = parseInt(quantityInput.min);
        const current = parseInt(quantityInput.value);

        if (current > max) {
          quantityInput.value = max;
          updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
          updateAddToCartButton();
          updateQuantitySummary(quantityInput);
        } else if (current < min) {
          quantityInput.value = min;
          updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
          updateAddToCartButton();
          updateQuantitySummary(quantityInput);
        }
      });
    }
  };

  const updateQuantitySummary = (quantityInput) => {
    if (!quantityInput) return;

    const quantitySummary = document.querySelector('.quantity-summary');
    if (quantitySummary) {
      quantitySummary.textContent = `${quantityInput.value} Panel${quantityInput.value > 1 ? 's' : ''}`;
    }

    const primaryATC = document.querySelector('.primary-atc');
    if (primaryATC) {
      const quantityField = primaryATC.querySelector('#quantity');
      if (quantityField) {
        quantityField.value = quantityInput.value;
      }
    }
  };

  const updateColorSelection = () => {

    const colorVariantsFull = document.querySelector('.color-variants-full');
    //console.log("colorVariantsFull", colorVariantsFull );
    if (colorVariantsFull) {
      const activeColor = colorVariantsFull.querySelector('.is-active');
      //console.log("activeColor", activeColor );
      if (activeColor) {
        const colorValue = activeColor.dataset.color;
        //console.log("color value", colorValue );
        if (colorValue) {
          // document.getElementById('attr_color').value = colorValue;
          const selectedColorTitle = document.querySelector('.selected-color-title');
          if (selectedColorTitle) {
            selectedColorTitle.innerHTML = colorValue;
          }
        }
      }
    }
  };

  // Set default selections for lining and header
  const setDefaultSelections = () => {
    //console.log('Setting default selections...');

    // Select first available lining option
    const liningButtons = document.querySelectorAll('.select-lining-btn');
    if (liningButtons.length > 0) {
      //console.log('Auto-selecting first lining option');
      liningButtons[0].click();
    }

    // Select first available header option
    const headerButtons = document.querySelectorAll('.product-options-card__select-header');
    if (headerButtons.length > 0) {
      //console.log('Auto-selecting first header option');
      headerButtons[0].click();
    }

    // Update displays after default selections
    setTimeout(() => {
      updateSelectionDisplay();
      updateYardsDisplay();
      updateQuantityInput();
      updateAddToCartButton();
      updateColorSelection();
      document.dispatchEvent(new CustomEvent('hpd:configurator:selection-updated'));

      // Mark initialization as complete and calculate price once
      isInitializing = false;
      calculatePrice();
      //console.log('Default selections complete');
    }, 100);
  };

  // Get current configuration
  const getCurrentConfiguration = () => {
    return {
      width: widthValue,
      height: lengthValue,
      selectedLining: window.selectedLining,
      selectedHeader: window.selectedHeader,
      selectedProduct: getSelectedProductData(),
      variantId: getVariantId(),
      pricePerYard: document.querySelector('input[name="price_per_yard"]')?.value,
      quantity: parseInt(document.getElementById('product-configurator-quantity')?.value) || 1
    };
  };

  // Common initialization function
  const initialize = () => {
    initializeDropdowns();
    subscribeToQuantityUpdates();
    updateAddToCartButton(); // Initialize button state

    // Set default selections after a short delay to ensure DOM is fully ready
    setTimeout(() => {
      setDefaultSelections();
    }, 200);

  };
  initialize();

  // Expose functions globally if needed
  window.productConfigurator = {
    getCurrentConfiguration,
    updateDisplay,
    calculatePrice,
    updateTotalPriceDisplay,
    updateAddToCartButton,
    widthValue: () => widthValue,
    lengthValue: () => lengthValue
  };

  const triggerBtn = document.querySelector('.form__label-help--size-modal');
  const targetEl = document.querySelector('.measurement-popup-modal__button');

  if (triggerBtn && targetEl) {
    triggerBtn.addEventListener('click', function(e) {
      e.preventDefault();
      targetEl.click();
    });
  }
})();